import * as yup from "yup"
import { Opera } from "../../types"

export function initialValuesOpera(opera?: Opera | undefined) {
  if (opera) {
    return opera
  }
  return {
    titolo: "",
    autore: undefined,
    destinatari: [],
    destinatario: undefined,
    traduttore: undefined,
    bibliografia: "",
    varianti_autore: "",
    varianti_titolo: "",
    edizioni_scritte_a_mano: "",
    edizioni_di_letture: "",
    bozza: true,
  }
}

export function validationSchemaOpera() {
  return yup.object().shape({
    titolo: yup.string().required("Campo obbligatorio"),
    autore: yup.number().required("Campo obbligatorio"),
  })
}
